import UserService from '../../../services/UserService';

export default {
    namespaced: true,
    state: () => ({
        userList: '',
        userFields: [],
    }),
    getters: {
        getUserList: state => state.userList,
    },
    mutations: {
        setuserList: (state, data) => {
            state.userList = data
        },
        setUserFields: (state, data) => {
            state.userFields = data
        }
    },
    actions: {
        getUserList: ({commit}) => {
            return new Promise((resolve, reject) => {
                UserService.userList().then(res => {
                        commit('setuserList', res.data)
                        resolve(res)
                }).catch((err) => {
                        reject(err)
                })
            })
        },
       newUser: ({dispatch}, userData) => {
            return new Promise((resolve, reject) => {
                UserService.newUser(userData).then(res => {
                    dispatch('getUserList')
                    resolve(res)
                }).catch((err) => {
                    reject(err)
                })
            })
        },
        updateUser: ({dispatch}, userData) => {
             return new Promise((resolve, reject) => {
                 UserService.updateUser(userData).then(res => {
                     dispatch('getUserList')
                     resolve(res)
                 }).catch((err) => {
                     reject(err)
                 })
             })
         },
        updatePassword: ({dispatch}, userData) => {
            return new Promise((resolve, reject) => {
                UserService.updatePassword(userData).then(res => {
                    dispatch('getUserList')
                    resolve(res)
                }).catch((err) => {
                    reject(err)
                })
            })
        },
        deleteUser: ({dispatch}, userID) => {
            return new Promise((resolve, reject) => {
                UserService.deleteUser(userID).then(res => {
                    dispatch('getUserList')
                    resolve(res)
                }).catch((err) => {
                    reject(err)
                })
            })
        },
        userFields: ({commit}) => {
            return new Promise((resolve, reject) => {
                UserService.userFields().then(res => {
                    commit('setUserFields')
                    resolve(res)
                }).catch((err) => {
                    reject(err)
                })
            })
        }
    },
}